import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Toast,
  Loading,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";
import { useParams } from "react-router-dom";

export const EditDeal = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(true);
  const [nameValue, setNameValue] = useState("");
  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
    setNameError("");
  };
  const [selectedType, setSelectedType] = useState("");
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });

    setTypeError("");
  };
  const optionsTypes = [
    { label: "Service", value: "1" },
    { label: "Product", value: "2" },
  ];
  const [typeError, setTypeError] = useState("");
  const [selectedSource, setSelectedSource] = useState("");
  const handleSelectChangeSource = (newValue) => {
    setItem({ ...item, source: newValue });
  };
  const optionsSources = [
    { label: "Crm", value: "1" },
    { label: "Website", value: "2" },
    { label: "Campaign", value: "3" },
    { label: "Advertisment", value: "4" },
    { label: "Employee Referral", value: "5" },
    { label: "External Referral", value: "6" },
    { label: "Web Research", value: "7" },
    { label: "Partner", value: "8" },
    { label: "Public Relation", value: "9" },
    { label: "Cold Call", value: "10" },
  ];
  const [costValue, setCostValue] = useState("");
  const handleChangeCost = (newValue) => {
    setItem({ ...item, cost: newValue });
  };

  const [priceValue, setPriceValue] = useState("");
  const handleChangePrice = (newValue) => {
    setItem({ ...item, price: newValue });
  };
  const [purchasePriceValue, setPurchasePriceValue] = useState("");
  const handleChangePurchasePrice = (newValue) => {
    setItem({ ...item, purchasePrice: newValue });
  };
  const [selectedReasonForLoss, setSelectedReasonForLoss] = useState("");
  const handleSelectChangeReasonForLoss = (newValue) => {
    setItem({ ...item, reasonForLoss: newValue });
  };
  const optionsReasonForLoss = [
    { label: "Expectation mismatch", value: "1" },
    { label: "Price", value: "2" },
    { label: "Unqualified", value: "3" },
    { label: "Customer", value: "4" },
    { label: "Lack of response", value: "5" },
    { label: "Missed follow-ups", value: "6" },
    { label: "Wrong target", value: "7" },
  ];
  const [noteValue, setNoteValue] = useState("");
  const handleChangeNote = (newValue) => {
    setItem({ ...item, note: newValue });
  };
  const [startDateValue, setStartDateValue] = useState("");
  const handleChangeStartDate = (newValue) => {
    setItem({ ...item, startDate: newValue });
    setStartDateError("");
  };
  const [startDateError, setStartDateError] = useState("");
  const [expectedCloseDateValue, setExpectedCloseDateValue] = useState("");
  const handleChangeExpectedCloseDate = (newValue) => {
    setItem({ ...item, expectedCloseDate: newValue });
    setExpectedCloseError("");
  };
  const [expectedCloseDateError, setExpectedCloseError] = useState("");
  const [actualCloseDateValue, setActualCloseDateValue] = useState("");
  const handleChangeActualCloseDate = (newValue) => {
    setItem({ ...item, actualCloseDate: newValue });
  };
  const [categories, setCategories] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const handleSelectChangeCampaign = (value) => {
    setItem({ ...item, campaign: value });
  };
  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSelectChangeStatus = (value) => {
    setSelectedStatus(value);
    setStatusError("");
  };
  const [statusError, setStatusError] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);

  const [companies, setCompanies] = useState([]);
  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const handleSelectChangeStage = (value) => {
    setItem({ ...item, stage: value });
    setStageError("");
  };
  const [stageError, setStageError] = useState("");

  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState("");
  const handleSelectChangeContact = (value) => {
    setItem({ ...item, contact: value });
    setContactError("");
  };
  const [contactError, setContactError] = useState("");
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const handleSelectChangeAdmin = (value) => {
    setItem({ ...item, admin: value });
  };
  const [nameError, setNameError] = useState("");
  const [item, setItem] = useState({
    name: "",
    type: "",
    cost: "",
    price: "",
    purchasePrice: "",
    admin: "",
    contact: "",
    campaign: "",
    startDate: "",
    expectedCloseDate: "",
    actualCloseDate: "",
    source: "",
    stage: "",
    reasonForLoss: "",
    note: "",
  });
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseCampaigns = "";
    let responseAdmins = "";
    let responseStages = "";
    let responseContacts = "";
    let responseDeal = "";
    try {
      responseContacts = await axios.get(`/crm/contacts`);
      responseContacts?.data?.data?.data &&
        setContacts(
          responseContacts.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name + " " + item?.last_name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCampaigns = await axios.get(`/crm/campaigns`);
      responseCampaigns?.data?.data?.data &&
        setCampaigns(
          responseCampaigns?.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    try {
      responseStages = await axios.get(`/crm/deal-stages`);
      responseStages?.data?.data?.data &&
        setStages(
          responseStages.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseAdmins = await axios.get(`/management/users`);
      responseAdmins?.data?.data?.data &&
        setAdmins(
          responseAdmins?.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name
                ? item?.first_name
                : "" + item?.last_name
                ? item?.last_name
                : "",
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    try {
      responseDeal = await axios.get(`/crm/deals/${id}`);
      setItem({
        name: responseDeal?.data?.data?.name ? responseDeal.data.data.name : "",
        type:
          responseDeal?.data?.data?.type?.id !== null
            ? String(responseDeal.data.data.type.id)
            : "",
        cost: responseDeal?.data?.data?.cost
          ? String(responseDeal.data.data.cost)
          : "",
        price: responseDeal?.data?.data?.price
          ? String(responseDeal.data.data.price)
          : "",
        purchasePrice: responseDeal?.data?.data?.purchase_price
          ? responseDeal.data.data.purchase_price
          : "",
        admin:
          responseDeal?.data?.data?.admin &&
          responseDeal?.data?.data?.admin?.id !== null
            ? String(responseDeal.data.data.admin.id)
            : "",
        contact:
          responseDeal?.data?.data?.contact?.id !== null
            ? String(responseDeal.data.data.contact.id)
            : "",
        campaign:
          responseDeal?.data?.data?.campaign &&
          responseDeal?.data?.data?.campaign?.id !== null
            ? String(responseDeal.data.data.campaign.id)
            : "",
        startDate: responseDeal?.data?.data?.start_date
          ? responseDeal.data.data.start_date
          : "",
        expectedCloseDate: responseDeal?.data?.data?.expected_close_date
          ? responseDeal.data.data.expected_close_date
          : "",
        actualCloseDate: responseDeal?.data?.data?.actual_close_date
          ? responseDeal.data.data.actual_close_date
          : "",
        source:
          responseDeal?.data?.data?.source &&
          responseDeal?.data?.data?.source?.id
            ? String(responseDeal.data.data.source.id)
            : "",
        stage: responseDeal?.data?.data?.stage?.id
          ? String(responseDeal.data.data.stage.id)
          : "",
        reasonForLoss:
          responseDeal?.data?.data?.reason_for_loss &&
          responseDeal?.data?.data?.reason_for_loss?.id
            ? String(responseDeal.data.data.reason_for_loss.id)
            : "",
        note: responseDeal?.data?.data?.notes
          ? responseDeal.data.data.notes
          : "",
      });
    } catch (error) {
      console.log(error);
    }
    setIsSaving(false);
  }
  const [active, setActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  return (
    <Page
      title="Edit Deal"
      narrowWidth
      backAction={{ onAction: () => navigate(`/admin/crm/deals`) }}
    >
      {isSaving ? <Loading /> : null}
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Name"
              value={item.name}
              onChange={handleChangeName}
              error={nameError}
            />
            <TextField
              label="Purchase Price"
              value={item.purchasePrice}
              onChange={handleChangePurchasePrice}
              type="number"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Cost"
              value={item.cost}
              onChange={handleChangeCost}
              type="number"
            />
            <TextField
              label="Price"
              value={item.price}
              onChange={handleChangePrice}
              type="number"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Type"
              options={optionsTypes}
              onChange={handleSelectChangeType}
              value={item.type}
              placeholder="Please select"
              error={typeError}
            />
            <Select
              label="Source"
              options={optionsSources}
              onChange={handleSelectChangeSource}
              value={item.source}
              placeholder="Please select"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Reason for loss"
              options={optionsReasonForLoss}
              onChange={handleSelectChangeReasonForLoss}
              value={item.reasonForLoss}
              placeholder="Please select"
            />
            <TextField
              label="Note"
              value={item.note}
              onChange={handleChangeNote}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Start Date"
              value={item.startDate}
              onChange={handleChangeStartDate}
              type="date"
              error={startDateError}
            />
            <TextField
              label="Expected Close Date"
              value={item.expectedCloseDate}
              onChange={handleChangeExpectedCloseDate}
              type="date"
              error={expectedCloseDateError}
            />
          </FormLayout.Group>
          <TextField
            label="Actudal Close Date"
            value={item.actualCloseDate}
            onChange={handleChangeActualCloseDate}
            type="date"
          />
          <FormLayout.Group>
            <Select
              label="Campaign"
              options={campaigns}
              onChange={handleSelectChangeCampaign}
              value={item.campaign}
              placeholder="Please select a campaign"
            />
            <Select
              label="Admin"
              options={admins}
              onChange={handleSelectChangeAdmin}
              value={item.admin}
              placeholder="Please select an admin"
              // error={companyError}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Stage"
              options={stages}
              onChange={handleSelectChangeStage}
              value={item.stage}
              placeholder="Please select a stage"
              error={stageError}
            />
            <Select
              label="Contact"
              options={contacts}
              onChange={handleSelectChangeContact}
              value={item.contact}
              placeholder="Please select a contacts"
              error={contactError}
            />
          </FormLayout.Group>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !item.name ||
      item.type === "" ||
      item.contact === "" ||
      !item.startDate ||
      !item.expectedCloseDate ||
      item.stage === ""
    ) {
      !item.name && setNameError("This field is required");
      item.type === "" && setTypeError("This field is required");
      item.contact === "" && setContactError("This field is required");
      item.type === "" && setTypeError("This field is required");
      !item.startDate && setStartDateError("This field is required");
      !item.expectedCloseDate &&
        setExpectedCloseError("This field is required");
      item.stage === "" && setStageError("This field is required");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: item.name,
        type: item.type,
        cost: item.cost,
        price: item.price,
        purchase_price: item.purchasePrice,
        admin_id: item.admin,
        contact_id: item.contact,
        campaign_id: item.campaign,
        start_date: item.startDate,
        expected_close_date: item.expectedCloseDate,
        actual_close_date: item.actualCloseDate,
        source: item.source,
        stage_id: item.stage,
        reason_for_loss: item.reasonForLoss,
        notes: item.note,
      };
      axios
        .patch(`/crm/deals/${id}`, bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/deals");
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            setToastContent(error.response.data.message);
            toggleActive();
            setIsSaving(false);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};
